/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiDataUploadStatus {
    NEW = 'NEW',
    READY = 'READY',
    FILE_UPLOADED = 'FILE_UPLOADED',
    PREPARING = 'PREPARING',
    QUEUED = 'QUEUED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED'
}


export function instanceOfInternalApiDataUploadStatus(value: any): boolean {
    for (const key in InternalApiDataUploadStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalApiDataUploadStatus, key)) {
            if (InternalApiDataUploadStatus[key as keyof typeof InternalApiDataUploadStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiDataUploadStatusFromJSON(json: any): InternalApiDataUploadStatus {
    return InternalApiDataUploadStatusFromJSONTyped(json, false);
}

export function InternalApiDataUploadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDataUploadStatus {
    return json as InternalApiDataUploadStatus;
}

export function InternalApiDataUploadStatusToJSON(value?: InternalApiDataUploadStatus | null): any {
    return value as any;
}

export function InternalApiDataUploadStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiDataUploadStatus {
    return value as InternalApiDataUploadStatus;
}

